export default __webpack_public_path__ + "static/media/personal1.960dc75d.jpeg";